module.exports = __webpack_public_path__ + "static/screenshot-6326dea00e4068f27d42ccd2c2514db3.png";